const SETTLED_STATUSES = ['confirmed', 'accepted'];

export const formatEventPaymentProgress = (payments) => {
  const mandatory = payments.filter((payment) => payment.products[0].mandatory);
  const settled = mandatory.filter((payment) =>
    SETTLED_STATUSES.includes(payment.status)
  );

  return `${settled.length}/${mandatory.length}`;
};
